'use strict';

require('../sections/articles-carousel/ArticlesCarousel');